import { render, staticRenderFns } from "./projectsSvg.vue?vue&type=template&id=a25fa1f6&"
import script from "./projectsSvg.vue?vue&type=script&lang=js&"
export * from "./projectsSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports